import { ModalSlideUpStaticMethods } from "@/components/composite/ModalSlideUp/main"
import TermsAndConditions, {
    signalIsTermsAndConditionsAgree,
    signalIsTermsAndConditionsProceeded,
} from "@/components/pagcor/TermsAndConditions"
import { PATHS } from "@/constants/path"
import { createLogger } from "@/utils/logger"
import { computed } from "@preact/signals"
import AppSignals from "./app"

const logger = createLogger("Pagcor")

const isTermsAndConditionsProceeded = computed(() => {
    return signalIsTermsAndConditionsProceeded.value && signalIsTermsAndConditionsAgree.value
})

function openTermsAndConditions() {
    if (AppSignals.isGlifeUser()) {
        return
    }
    ModalSlideUpStaticMethods.open("pagcor", <TermsAndConditions />, {
        closeOnClickMask: false,
        closeOnEscape: false,
    })
}

const Pagcor = {
    openTermsAndConditions,
    isTermsAndConditionsProceeded,
}

export default Pagcor
